import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import React, { Component } from 'react';
import Modal from 'react-modal';
import firebase from 'firebase';
import ModalCalificaciones from './ModalCalificaciones';
import Alert from 'react-s-alert';

const database=firebase.database();

const customStyles = {
  content : {
    top                   : '50%',
    left                  : '50%',
    right                 : 'auto',
    bottom                : 'auto',
    transform             : 'translate(-50%, -50%)',
	width                 : '700px'
	
  }
};


class Calificaciones extends Component{
	
	constructor(props){
		
		super(props)
		this.state={
			
				calificaciones:[],
				items:[],
				preguntasEditar:[],
				preguntasEliminar:[],
				preguntasAgregar:[],
				isActive:false,
				estado:'',
				tipo:'',
				nodoKey:'',
				template:false
				

		}		
		
		
		this.CalificacionesRef= database.ref().child('Calificaciones');
		this.handleClickEliminarPagina=this.handleClickEliminarPagina.bind(this);
		this.handleClick=this.handleClick.bind(this);
		this.toggleModal=this.toggleModal.bind(this); 	
		this.handleSubmit=this.handleSubmit.bind(this);
		this.ingresarPregunta=this.ingresarPregunta.bind(this);
	}
	
	
	componentDidMount(){
		
		this.CalificacionesRef.on('value',this.gotData,this.errData);

	}
	componentWillMount(){
		
	}

	gotData=(data)=>{

		let newCalificacion=[];
		let preguntas=[];
		let datacalificaciones=data.val();


		if(datacalificaciones!==null){

			let keys=Object.keys(datacalificaciones);

			for(let i=0;i<keys.length;i++){
			
				let k=keys[i];


				
				database.ref().child('Calificaciones').child(k).child('preguntas').on('value', function(snapshot) {
				
					if(snapshot.exists()){

						let datapreguntas=snapshot.val();
						preguntas=[]

						if(datapreguntas!=null){

								let newPregunta=[]

								let keysw=Object.keys(datapreguntas);

								for(let i=0;i<keysw.length;i++){
									
									let kw=keysw[i];

									preguntas.push({
										key:kw,
										item:datapreguntas[kw].item
									})	
								}
								newCalificacion.push({
									key:k,
									tipo:datacalificaciones[k].tipo,
									estado:datacalificaciones[k].estado,
									preguntas:preguntas

								})
								
								
			
						}
			
					}

				});

				
			}
			this.setState({calificaciones:newCalificacion});
	
		}

		

	}
	errData=(err)=>{

		console.log(err);



	}


	toggleModal(){

		this.setState({

		isActive:!this.state.isActive ,
		preguntasEliminar:[],
		preguntasAgregar:[]

		})

	}


	imgFormatter(cell,row) {
		 
		return  <button className="btn btn-success btn-sm" onClick={() => {this.handleClick(row)}} >Editar</button>;
	}

	handleClick(row){
		
		
		
		this.setState({
			nodoKey:row.key,
			tipo:row.tipo,
			preguntasEditar:row.preguntas,
			estado:row.estado
		})



		this.toggleModal();
	}


	btnEliminarFormatter(cell,row){
				
		return <p className="glyphicon glyphicon-remove btn-eliminar" onClick={() => {this.handleClickEliminarPagina(row)}} ></p>
	}
	
	handleClickEliminarPagina(row){

		this.state.preguntasEliminar.push({
			key:row.key,
			item:row.item
		})

			
		let nuevoArray=this.state.preguntasEditar.filter(preguntas=>preguntas.item!==row.item)

		this.setState({
			
			preguntasEditar:nuevoArray,
			preguntasEliminar:this.state.preguntasEliminar
				

		})

	

	}
	
	handleSubmit(event){

		let estado=this.estado.value;
		let tipo=this.tipo.value;

		if(this.state.preguntasEditar.length!==0){

			database.ref().child('Calificaciones').child(this.state.nodoKey).update({

				estado:estado,
				tipo:tipo
			})
			

			for(let i=0;i<this.state.preguntasEliminar.length;i++){

				database.ref().child('Calificaciones').child(this.state.nodoKey).child('preguntas').child(this.state.preguntasEliminar[i].key).remove();	
			}

			for(let i=0;i<this.state.preguntasAgregar.length;i++){

				database.ref().child('Calificaciones').child(this.state.nodoKey).child('preguntas').push({
					item:this.state.preguntasAgregar[i].item
				})	
			}
			Alert.success('Datos guardados correctamente', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
				});
			
			this.toggleModal();
		}
		else{

			Alert.warning('Debes ingresar al menos una pregunta', {
					effect: 'genie',
					position: 'bottom-right',
					timeout:2000			
			});
		}
		event.preventDefault();
	}


	ingresarPregunta(){

		let pregunta=this.pregunta.value;

		if(pregunta!==''){
		
			this.state.preguntasAgregar.push({
			key:this.state.preguntasEditar.length,
			item:pregunta
			
			})
		
			this.state.preguntasEditar.push({
				key:this.state.preguntasEditar.length,
				item:pregunta
			})

			this.setState({
				preguntasEditar:this.state.preguntasEditar
			})

			this.pregunta.value="";
			
		}
		
		
		
	}

	render(){
		
		return(
		
			<div className="calificaciones container">
			
				 <h1 className="titulo">Calificaciones</h1>
				

				{this.state.template ? <Alert  timeout='none' contentTemplate={this.AlertaContenido} />:<Alert stack={{limit: 3}} html={true} />}

				<ModalCalificaciones/>
				  <BootstrapTable data={ this.state.calificaciones }
					 ref='table'			 
					 pagination={ true }
					 search={ true }
					 hover
					 >
					 <TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
					 <TableHeaderColumn dataField='tipo'  dataSort={true}  >Tipo</TableHeaderColumn>
					 <TableHeaderColumn dataField='estado'  dataSort={true}  >Estado</TableHeaderColumn>
					 <TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.imgFormatter.bind(this) }>Editar</TableHeaderColumn>
				  </BootstrapTable>
					
		
				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles}>
				

					<form method="POST" action="" onSubmit={this.handleSubmit}>


					<h3>Editar Calificación</h3>
					<hr/>
					<div className="form-group">
							<label htmlFor="">Tipo de Calificación</label>
							<input type="text" required autoComplete="off"
								placeholder="Tipo"  className="form-control"
								ref={input=>{this.tipo=input}}
								defaultValue={this.state.tipo}
					/>
					
	
						<h4>Ingresa una pregunta</h4>
						<hr/>
						
						<input type="text" name="pregunta" className="form-control" 
						 autoComplete="off" placeholder="Ingresa una pregunta" 
							ref={input=>{this.pregunta=input}}
						
						/>
						<br/>
						<button type="button" className="btn btn-success btn-sm" onClick={this.ingresarPregunta}>Agregar pregunta</button>
	
						<br/>
						<br/>
							
						<BootstrapTable data={ this.state.preguntasEditar}
							 ref='table'
							 pagination={ false }
							 search={ false }
							 hover
							 >
							<TableHeaderColumn dataField='key' isKey={true} dataSort={true} hidden >Nombre</TableHeaderColumn>
							<TableHeaderColumn dataField='item' dataSort={true}>Preguntas</TableHeaderColumn>
							<TableHeaderColumn dataField='edit' dataAlign='center' dataFormat={ this.btnEliminarFormatter.bind(this) }>Eliminar</TableHeaderColumn>					
						</BootstrapTable>		
					<br/>
					<div className="form-group">	
							<label  htmlFor="estado">Estado</label>
							<select name="estado" className="form-control"
								ref={input=>{this.estado=input}}	
								defaultValue={this.state.estado}
							>
									<option>Activo</option>
									<option>Inactivo</option>
							</select>

					</div>


					</div>
					
							<button className="btn btn-primary buttons" type="submit" >Guardar</button>
					</form>
							<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
				
				</Modal>
	
							
			</div>
			
			
			
			
		
		);		
	}
}

export default Calificaciones;


// WEBPACK FOOTER //
// ./src/Components/Calificaciones/Calificaciones.js